import React from 'react'
import SubLabel from './SubLabel'
import {Flex} from '/app/src/component'
import style from './style.css'

export default class Label extends React.Component {
    render(){
        return (
            <Flex color='black' shrink={0} className={style.Label} onClick={this.props.onClick} width='100%' vAlignContent='center' {...this.props}>
                {this.props.children}
            </Flex>
        )
    }

}

export {Label, SubLabel}



// WEBPACK FOOTER //
// ./src/component/Label/index.js